import { FarmOptionsTypes } from '../CustomizeColumns/types';
import { Farm, FarmKpiResponse } from '../../rtk/farmsApi';

export const getBasicsDefaultFiltersForFarmsList =
  (): FarmOptionsTypes.Selection[] => {
    return basicSelectionOptions;
  };

export const basicSelectionOptions = [
  { key: 'farmName', name: 'Farm name' },
  { key: 'centerName', name: 'Lely center' },
  { key: 'clusterName', name: 'Lely cluster' },
  { key: 'city', name: 'City / village' },
  { key: 'country', name: 'Country' },
  { key: 'customerNumber', name: 'Customer number' },
  { key: 'siteId', name: 'Site id' },

];

export const advancedSelectionOptions = [
  { key: 'version', name: 'Vector software version' },
];

export const engineeringSelectionOptions = [{ key: 'siteId', name: 'Site id' }];

export const mergeFarmsWithKpis = (
  farms: Farm[] = [],
  kpiPayload: FarmKpiResponse[] = [],
): Farm[] => {
  return farms.map((farm) => {
    const kpiData = kpiPayload.find((kpi) => kpi.id === farm.id);

    if (kpiData) {
      const flattenedKpis = kpiData.dailyVectorKpi.reduce((acc, item) => {
        const key =
          item.kpiName.charAt(0).toLowerCase() +
          item.kpiName.slice(1).replace(/\./g, '').replace(/ /g, '');

        acc[key] = `${item.value}`;
        return acc;
      }, {} as Record<string, string>);

      return {
        ...farm,
        accuracy: '',
        freetime: '',
        durationalarmstate: '',
        nrofloads: '',
        loadedweight: '',
        nrofalarms: '',
        version: kpiData.version ?? '',
        ...flattenedKpis,
      };
    }

    return {
      ...farm,
      accuracy: '',
      freeTime: '',
      durationalarmstate: '',
      nrofloads: '',
      loadedweight: '',
      nrofalarms: '',
      version: '',
    };
  });
};

export const markFarmAsFavourite = (favouriteIds: string[], farm: Farm) =>
  favouriteIds.includes(farm.id) ? { ...farm, isFavourite: true } : farm;

export const VECTOR_KPIS = [
  { key: 'freetime', name: 'Free time (%)' },
  { key: 'accuracy', name: 'Accuracy (%)' },
  { key: 'nrofalarms', name: 'Nr. of alarms' },
  { key: 'durationalarmstate', name: 'Duration alarm state' },
  { key: 'nrofloads', name: 'Nr. of loads' },
  { key: 'totalloadedweight', name: 'Total loaded weight (kg)' },
];
